export default "__VITE_ASSET__DvrL1lvP__"